import classNames from './styles.module.scss'


export default function Dot() {
  return <div className={classNames.dot} />
}
